import { koComponent } from '../ko-utils';

class Switcher {
    constructor(params) {
        this.items = params.items;
        this.onChange = params.onChange;

        this.selectedValue = ko.observable(ko.unwrap(params.initalValue || this.items[0].val));

        this.typeCss = ko.observable(ko.unwrap(params.type));
    }

    setValue(val) {
        this.selectedValue(val.val);

        if (this.onChange) {
            this.onChange(val);
        }
    }
}

export default koComponent('switcher', Switcher);